export interface ItemProps {
    range: string;
    discount: string;
    min: number;
    max?: number;
}

export interface ItemWithLoginProps extends ItemProps {
    checked: boolean;
}

export type TcProps = Pick<ItemProps, 'range' | 'discount'>;
export type TcWithLoginProps = Pick<ItemWithLoginProps, 'range' | 'discount' | 'checked'>;

const termsMap: Record<string, ItemProps[]> = {
    us: [
        { range: '[$0-$2000)', discount: 'Basic Discount 5%', min: 0, max: 2000 },
        { range: '[$2000-$5000)', discount: 'Limited Discount 6%', min: 2000, max: 5000 },
        { range: '[$5000-$10000)', discount: 'Premium Discount 7%', min: 5000, max: 10000 },
        { range: 'More than $10000', discount: 'Elite Discount 8%', min: 10000 },
    ],
    ca: [
        { range: '[$0-$2000)', discount: 'Basic Discount 5%', min: 0, max: 2000 },
        { range: '[$2000-$5000)', discount: 'Limited Discount 6%', min: 2000, max: 5000 },
        { range: '[$5000-$10000)', discount: 'Premium Discount 7%', min: 5000, max: 10000 },
        { range: 'More than $10000', discount: 'Elite Discount 8%', min: 10000 },
    ],
};

const termsMapWithLogin: Record<string, ItemWithLoginProps[]> = {
    us: [
        { range: '[$0-$2000)', discount: 'Basic Discount 5%', min: 0, max: 2000, checked: false },
        { range: '[$2000-$5000)', discount: 'Limited Discount 6%', min: 2000, max: 5000, checked: false },
        { range: '[$5000-$10000)', discount: 'Premium Discount 7%', min: 5000, max: 10000, checked: false },
        { range: 'More than $10000', discount: 'Elite Discount 8%', min: 10000, checked: false },
    ],
    ca: [
        { range: '[$0-$2000)', discount: 'Basic Discount 5%', min: 0, max: 2000, checked: false },
        { range: '[$2000-$5000)', discount: 'Limited Discount 6%', min: 2000, max: 5000, checked: false },
        { range: '[$5000-$10000)', discount: 'Premium Discount 7%', min: 5000, max: 10000, checked: false },
        { range: 'More than $10000', discount: 'Elite Discount 8%', min: 10000, checked: false },
    ],
};

const halfOpenInterval = (value: number, min: number, max: number) => {
    if (!max) return min <= value;
    return min <= value && value < max;
};

const getRangeTable = (locale: string, isLogin?: boolean, couponName?: string) => {
    if (isLogin) {
        const list = termsMapWithLogin[locale] || [];
        console.log({ list });
        console.log({ couponName });
        const newList = list
            .map((item) => {
                if (item.discount === couponName) item.checked = true;
                return item;
            })
            .map((item) => ({ range: item.range, discount: item.discount, checked: item.checked })) as TcWithLoginProps[];
        return newList;
    } else {
        const data = termsMap[locale] && (termsMap[locale].map((item) => ({ range: item.range, discount: item.discount })) as TcProps[]);
        return data || [];
    }
};

export { termsMap, termsMapWithLogin, getRangeTable, halfOpenInterval };
